/**
 * The roll-up strip under the builder's toolbar: a Roll-Up badge and an
 * "N Clients" button opening the client list, as in AgencyAnalytics. The
 * choice is saved with the document; every roll-up widget follows it.
 */

import { useEffect, useRef, useState, type ReactNode } from 'react';

import { ClientMultiPicker } from './ClientMultiPicker.tsx';
import { useRollup } from './rollup-context.ts';

export function RollupBar(): ReactNode {
  const rollup = useRollup();
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState<string[]>([]);
  const box = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event: KeyboardEvent) => event.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  if (!rollup) return null;
  const count = rollup.clientIds.length;
  return (
    <div className="rb-rollup" ref={box}>
      <span className="rb-rollup-badge">Roll-Up</span>
      <div className="ex-filter">
        <button
          type="button"
          className="btn secondary"
          aria-expanded={open}
          onClick={() => {
            setDraft(rollup.clientIds);
            setOpen(!open);
          }}
        >
          {count} {count === 1 ? 'Client' : 'Clients'} ▾
        </button>
        {open && (
          <div className="ex-pop rb-rollup-pop" role="dialog" aria-label="Clients in this roll-up">
            <ClientMultiPicker clients={rollup.clients} selected={draft} onChange={setDraft} />
            <div className="kp-dialog-actions">
              <button type="button" className="btn secondary" onClick={() => setOpen(false)}>
                Cancel
              </button>
              <button
                type="button"
                className="btn"
                disabled={draft.length === 0}
                onClick={() => {
                  rollup.setClientIds(draft);
                  setOpen(false);
                }}
              >
                Apply
              </button>
            </div>
          </div>
        )}
      </div>
      <span className="kp-faint">
        Widgets add these clients together; choose Dimension “Client” to compare them, or one client
        in a widget’s Data.
      </span>
    </div>
  );
}
